<template>
    <div class="form-group">
        <label for="permit-number-file">Copy of your Permit</label>
        <div class="input-group">
            <div class="custom-file">
                <input id="permit-number-file" :readonly="readonly" type="file" ref="file" class="custom-file-input" @change="handleFileUpload()">
                <label class="custom-file-label" for="permit-number-file">Choose file</label>
            </div>
        </div>
        <div v-if="download_url" class="d-flex align-items-center w-100">
            <a target="_blank" :href="download_url">View Download</a>
            <button type="button"
                    @click.prevent="deleteFile()"
                    class="text-danger ml-auto mb-0 mt-0 mr-0 btn btn-sm">
                <i class="fa fa-times"></i>
            </button>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        project: {
            type: Object,
            required: true,
        },
        value: {
            required: true
        },
        readonly: {
            required: false,
            type: Boolean,
            default: false,
        }
    },

    data() {
        return {
            download_url: this.project.permit_file_url,
            file_uploaded_at: this.value,
            form: new Form({}),
        }
    },

    methods: {
        handleFileUpload() {
            let formData = new FormData;
            let file = this.$refs.file.files[0]

            formData.append('permit_number', file)
            App.request().post(`/projects/${this.project.slug}/permit-number`, formData).then(response => {
                this.download_url = response.data.url;
                this.file_uploaded_at = response.data.permit_file_uploaded_at;
                this.$emit('input', this.file_uploaded_at)
                this.$refs.file.value = ""
                Toast.success('File uploaded succesfully')
            }).catch(errors => {
                Toast.error('Invalid format must be of type: pdf, png, jpg, jpeg, gif.')
            })
        },

        deleteFile() {
            App.request().delete(`/projects/${this.project.slug}/permit-number`)
                .then(response => {
                    this.download_url = null
                    this.file_uploaded_at = null;
                    this.$emit('input', null)
                    this.$refs.file.value = ""
                })
                .catch(errors => {
                    if(errors.hasOwnProperty('message')){
                        Toast.error(errors.response.data.message)
                    }
                })
        }
    }
}
</script>
